  <template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $t("censor") }} {{ $tc("rating", 1) }}
        </div>
        <div class="section-subTitle my-2">{{ $t("rating_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="!isEditable && $can('create', 'Censor Ratings')"
          variant="default"
          class="btn-blue"
          @click="isRatingEditable()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button
          v-if="isEditable && $can('create', 'Censor Ratings')"
          variant="default"
          class="btn-blue"
          @click="updateRatings()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-if="$can('create', 'Censor Ratings')"
          variant="default"
          to="add-rating"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
        <b-dropdown
          :text="filterButtonTitle"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item @click="filterRating('Active')"
            >Active</b-dropdown-item
          >
          <b-dropdown-item @click="filterRating('Inactive')"
            >Inactive</b-dropdown-item
          >
          <b-dropdown-item @click="filterRating('All')">All</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getRatingsList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Ratings.length > 0"
        v-for="(item, key) in Ratings"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.rating, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Censor Ratings')"
                  @click="goToRoute('/master/edit-rating', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-rating', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.rating_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.rating_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Ratings.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'rating'"
              @click="onSortValue('rating', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('rating', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('rating', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("censor") }} {{ $tc("rating", 1) }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'r_order' || !isSort"
              @click="onSortValue('r_order', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('r_order', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('r_order', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("order") }}
          </th>
        </tr>
      </thead>
      <template v-if="Ratings.length > 0">
        <draggable
          :list="this.Ratings"
          tag="tbody"
          @end="endSort($event)"
          :move="draggableElements"
        >
          <tr v-for="(item, key) in Ratings" :key="key">
            <!-- <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.rating_is_active ? 'active' : 'inactive'"
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Censor Ratings')"
                    @click="goToRoute('/master/edit-rating', item)"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/master/view-rating', item)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.rating_is_active ? 'active' : 'inactive'"
                />
                <div
                  v-if="$can('update', 'Censor Ratings')"
                  class="ml-4 clickable-icon"
                  @click="goToRoute('/master/edit-rating', item)"
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
                <div
                  class="ml-2 clickable-icon"
                  @click="goToRoute('/master/view-rating', item)"
                  style="cursor: pointer"
                  v-b-tooltip="'View'"
                  tabindex="0"
                >
                  <i class="icon-eye icon blue-icon"></i>
                </div>
              </div>
            </td>

            <td>{{ $tc(item.rating, 1) }}</td>
            <td>{{ item.r_order }}</td>
          </tr>
        </draggable>
      </template>
      <tbody v-if="Ratings.length == 0">
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Ratings.length > 0 && isEditable == false"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Ratings from "@/helper/formJSONMaster/Ratings";
import draggable from "vuedraggable";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    draggable,
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Ratings.Methods,
      Ratings: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "asc",
      columnName: "r_order",

      debounce: null,
      searchValue: "",
      searchKey: "rating",

      // is rating editable
      isEditable: false,
      filterButtonTitle: "Filters",
    };
  },
  beforeMount() {
    this.getRatingsList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    endSort(event) {
      this.Ratings.map((x, index) => {
        if (this.currentPage != 1) {
          x.r_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.r_order = index + 1;
        }
      });
      console.log("this.sorted Rating", this.Ratings);
      console.log("this.event", event);
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getRatingsList();
      } else {
        this.currentPage = event;
        this.getRatingsList();
      }
    },
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { rating_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: rating_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getRatingsList();
    },
    getRatingsList: function () {
      this.Ratings = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}`;
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.$store.dispatch("setRatings", data.Records);
              this.Ratings = data.Records;
              this.filterRating("Active");
              // this.Ratings.map((x, index) => {
              //   if(this.currentPage != 1) {
              //     x.r_order = (this.perPage * (this.currentPage -1)) + (index + 1)
              //   } else {
              //     x.r_order = (index + 1)
              //   }
              // })
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    filterRating: function (status) {
      // filter all rating based status
      this.filterButtonTitle = status;
      let ratings = this.$store.getters.getRatings;
      if (status === "Active") {
        this.Ratings = ratings.filter(
          (rating) => rating.rating_is_active == true
        );
      }
      if (status === "Inactive") {
        this.Ratings = ratings.filter(
          (rating) => rating.rating_is_active == false
        );
      }
      if (status === "All") {
        this.Ratings = ratings;
      }
    },
    isRatingEditable: function () {
      // if isEditable is true disable pagnition and show all the rating with active status and enable drag and drop of rating
      this.isEditable = true;
      let active_rating = [];
      if (this.isEditable) {
        this.onDropDownChangeValue("All");
        this.filterRating("Active");
      }
    },
    updateRatings: function () {
      this.isEditable = false;
      let body = {
        ratings: this.Ratings,
      };
      MasterService.updateRating(body)
        .then((data) => {
          console.log(data);
          if (data && data.status) {
            this.filterRating("Active");
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    draggableElements: function () {
      return this.isEditable;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/RatingsComponents/ratings.vue